/*
 * @Author: jianwei.chen
 * @Date: 2024-03-25 15:35:19
 * @Description: Amount
 */
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from 'react';
import { observer } from 'mobx-react';
import { calc } from '@ok/blade';
import { Input, Slider } from '@ok/okd';
import { format } from '@ok/trade-common';

import PrefixSuffix from '_common/bizComps/PrefixSuffix';
import { DECIMAL, SLIDER_MARKS } from '_common/consts/trade';

import Store from './Store';
import styles from './index.module.less';

const { ROUND } = DECIMAL;

const AmountWithSlider = forwardRef((props, ref) => {
  const { className, available, min, max, disabled } = props;

  const [store] = useState(() => {
    return new Store(props);
  });

  // 暴露方法出去可供调用
  useImperativeHandle(ref, () => {
    return {
      validPass: () => {
        return store.validPass();
      },
      resetData: () => {
        store.resetData();
      },
    };
  });

  // 需要实时更新的
  useEffect(() => {
    store.update({
      available,
      min,
      max,
    });
  }, [available, min, max]);

  const {
    preText,
    quoteCcy,
    sizeDig,
    amt,
    amtError,
    sliderValue,
    placeholder,
    onChange,
    onBlur,
    onSliderChange,
  } = store;

  const showPlaceholder = useMemo(() => {
    return disabled ? '' : placeholder;
  }, [disabled, placeholder]);

  return (
    <div className={className}>
      <Input.Number
        className={styles.inputNumberStyle}
        value={amt}
        error={amtError}
        errorType={Input.TIP_TYPE.always}
        onChange={onChange}
        onBlur={onBlur}
        precision={+sizeDig}
        prefix={<PrefixSuffix text={preText} />}
        suffix={<PrefixSuffix text={quoteCcy} isSuffix />}
        size={Input.SIZE.sm}
        placeholder={showPlaceholder}
        inputStyle={{
          textAlign: 'right',
          paddingRight: '8px',
          padddingLeft: '8px',
        }}
        disabled={disabled}
      />
      <Slider
        className={styles.strategySlider}
        value={
          +format.precision({ value: sliderValue, decimal: ROUND, digit: 0 })
        }
        marks={SLIDER_MARKS}
        onChange={onSliderChange}
        disabled={!available || disabled}
        formatValue={(v) => {
          return calc.showTruncation(v, 0, { style: 'percent' });
        }}
        size={Slider.SIZE.sm}
      />
    </div>
  );
});

export default observer(AmountWithSlider);
